import { atomWithStorage } from "jotai/utils";

export const auctionWizardUnknownCheckBoxAtom = atomWithStorage<boolean>(
  "auctionWizardUnknownCheckBoxAtom",
  false,
  undefined,
  { getOnInit: true }
);
